<template>
    <div class="homepage__teachers-love-it">
        <h2 class="love-it__title">
            {{ $t('lp.teachersLoveIt.title') }}
        </h2>
        <div class="love-it__reasons">
            <div class="reason">
                <img
                    class="reason__visual"
                    src="/images/lp/reason--curriculum.svg"
                    :alt="$t('lp.teachersLoveIt.curriculum.title')"
                />
                <h3 class="reason__title">
                    {{ $t('lp.teachersLoveIt.curriculum.title') }}
                </h3>
                <p class="reason__content">
                    {{ $t('lp.teachersLoveIt.curriculum.description') }}
                </p>
            </div>
            <div class="reason">
                <img
                    class="reason__visual"
                    :src="`/images/lp/reason--improvement${imageLang}.svg`"
                    :alt="$t('lp.teachersLoveIt.easy.title')"
                />
                <h3 class="reason__title">
                    {{ $t('lp.teachersLoveIt.easy.title') }}
                </h3>
                <p class="reason__content">
                    {{ $t('lp.teachersLoveIt.easy.description') }}
                </p>
            </div>
            <div class="reason">
                <img
                    class="reason__visual"
                    src="/images/lp/reason--kids-love-it.svg"
                    :alt="$t('lp.teachersLoveIt.kidsLoveIt.title')"
                />
                <h3 class="reason__title">
                    {{ $t('lp.teachersLoveIt.kidsLoveIt.title') }}
                </h3>
                <p class="reason__content">
                    {{ $t('lp.teachersLoveIt.kidsLoveIt.description') }}
                </p>
            </div>
        </div>
        <h2 class="love-it__subtitle">
            {{ $t('lp.teachersLoveIt.freeForTeacherAndSchools') }}
        </h2>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters({ currentLanguage: 'getCurrentLanguage' }),
        imageLang() {
            switch (this.currentLanguage) {
                case 'es':
                    return '--spanish';
                case 'et':
                    return '--estonian';
                default:
                    return '';
            }
        },
    },
};
</script>

<style scoped lang="scss">
.homepage__teachers-love-it {
    text-align: center;
    background-color: #572598;
    padding: 100px 1rem;
    position: relative;

    @include mq($w-min-md, min) {
        padding: 150px 1rem 50px;
    }

    &::after {
        content: '';
        display: block;
        width: 100%;
        background-color: #572598;
        position: absolute;
        left: 0;
        z-index: 1;
        transform: skewY(4deg);
        bottom: -40px;
        height: 80px;

        @include mq($w-min-desktop, min) {
            transform: skewY(2deg);
        }
    }

    .love-it {
        &__title {
            font-style: normal;
            font-weight: bold;

            @include mq($w-min-md, min) {
                font-size: 2.625rem;
                line-height: 3.1875rem;
            }
        }

        &__subtitle {
            font-size: 1.25rem;
            line-height: 1.5rem;
            font-style: normal;
            font-weight: normal;
            margin: 3rem auto 1rem;

            @include mq($w-min-md, min) {
                font-size: 2.25rem;
                line-height: 130%;
            }
        }

        &__reasons {
            @include mq($w-min-md, min) {
                display: flex;
                justify-content: center;
            }

            .reason {
                margin-top: 2.875rem;
                text-align: center;

                @include mq($w-min-md, min) {
                    margin: 2.875rem 1.5rem 0;
                }

                &__visual {
                    display: inline-block;
                    height: 120px;
                    margin-bottom: 1rem;

                    @include mq($w-min-md, min) {
                        display: inline-block;
                        height: 160px;
                    }
                }

                &__title {
                    font-style: normal;
                    font-weight: bold;
                    font-size: 1.25rem;
                    line-height: 1.5rem;

                    @include mq($w-min-md, min) {
                        font-size: 1.5rem;
                        line-height: 1.81rem;
                    }
                }

                &__content {
                    font-style: normal;
                    font-weight: normal;
                    font-size: 1rem;
                    line-height: 150%;
                    margin: 0.25rem auto 0;
                    max-width: 350px;
                    display: flex;

                    @include mq($w-min-md, min) {
                        margin: 0.68rem auto 0;
                    }
                }
            }
        }
    }
}
</style>
